import React from 'react';
import './navbar.css';
import { useNavigate } from 'react-router-dom';

const Navbar = ({pagesLeft,pagesRight}) => {

    // Funzione per cambiare pagina
    const navigate=useNavigate();

    function goToPage(page){
        navigate(`/${page.toLowerCase()}`);
    };

    return (
        <div className="navbar">
            <div className="navbar-btn-container navbar-btn-container-left">
                {pagesLeft.map((page)=>(
                    <button key={page} className="navbar-btn navbar-btn-left" onClick={()=>(goToPage(page))}>
                        {page}
                    </button>
                ))}
            </div>
            <div className="navbar-btn-container navbar-btn-container-right">
                {pagesRight.map((page)=>(
                    <button key={page} className="navbar-btn navbar-btn-right" onClick={()=>(goToPage(page))}>
                        {page}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default Navbar